import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { MailOutline, LockOutlined, Login } from "@mui/icons-material";
import Logo from "../Images/logistics.png";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import Language from "../Pages/Language";
import { apiPost } from "../../utils/apiHelpers";
import "../Styles/Admin.css";

const Admin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleLogin = async () => {
    try {
      console.log("Payload being sent:", { email, password });

      if (!email || !password) {
        message.error(t("fields_required"));
        return;
      }

      setLoading(true);
      const response = await apiPost("login", {
        email,
        password,
      });
      console.log("Response received:", response);

      const token = response?.data?.token;

      if (token) {
        console.log(token);
        localStorage.setItem("sessionToken", token);
        window.location.href = "/";
      } else {
        setLoading(false);
        message.error(t("invalid_credentials"));
      }
    } catch (error) {
      setLoading(false);
      console.error("Login error:", error);

      if (error.response) {
        console.error("Response error data:", error.response.data);
        const status = error.response.status;

        if (status === 422) {
          message.error(t("invalid_crentials"));
        } else if (status === 401) {
          message.error(t("unauthorized"));
        } else {
          message.error(t("login_failed"));
        }
      } else if (error.request) {
        message.error(t("no_response_error"));
      } else {
        message.error(t("unexpected_error"));
      }
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-lang">
        <Language />
      </div>

      <div className="admin-login-center">
        <div className="admin-login-card-wrap">
          <Box className="admin-login-logo-wrap">
            <img src={Logo} alt="Company Logo" className="admin-login-logo" />
          </Box>
          <Paper elevation={0} className="login-paper" component="section">
            <Typography variant="h5" className="admin-login-title">
              {t("admin_login")}
            </Typography>
            <Typography variant="body2" color="textSecondary" className="admin-login-subtitle">
              {t("admin_login_subtitle") || "Sign in with your account"}
            </Typography>

            <TextField
              label={t("email")}
              placeholder={t("enterEmail") || "Enter your email"}
              variant="outlined"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              disabled={loading}
              className="admin-login-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailOutline className="admin-login-input-icon" />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label={t("password")}
              placeholder={t("enterPassword") || "Enter your password"}
              variant="outlined"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              autoComplete="current-password"
              disabled={loading}
              className="admin-login-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlined className="admin-login-input-icon" />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Login />}
              className="admin-login-btn"
              onClick={handleLogin}
            >
              {loading ? (t("logging_in") || "Signing in...") : t("login")}
            </Button>
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default Admin;
